import Swiper from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

Swiper.use([Autoplay, Navigation, Pagination]);

(function (Drupal, drupalSettings) {
  Drupal.behaviors.servicesCarousel = {
    attach(context) {
      // --- Services Carousel ---
      once("servicesCarouselInit", ".serviceCarousel", context).forEach(
        (el) => {
          const isRtl = document.documentElement.dir === "rtl";
          el.setAttribute("dir", isRtl ? "rtl" : "ltr");

          // Remove legacy inline values that conflict with the dimensions and
          // logical spacing Swiper calculates for the current direction.
          el.querySelectorAll(":scope > .swiper-wrapper > .swiper-slide").forEach(
            (slide) => {
              slide.style.removeProperty("width");
              slide.style.removeProperty("margin-left");
              slide.style.removeProperty("margin-right");
              slide.removeAttribute("data-swiper-slide-index");
            },
          );

          new Swiper(el, {
            autoplay: {
              delay: 5000,
            },
            slidesPerView: 2,
            spaceBetween: 16,
            // Loop mode reorders slides and can leave an edge slide clipped in
            // RTL when the number of items is close to slidesPerView. Rewind
            // keeps autoplay continuous without cloning/reordering the slides.
            loop: false,
            rewind: true,
            slidesPerGroup: 1,
            observer: true,
            observeParents: true,
            pagination: {
              el: el.querySelector(".serviceCarousel-pagination"),
              clickable: true,
            },
            breakpoints: {
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
              1440: { slidesPerView: 5 },
            },
          });
        },
      );

      // --------------------
      // Partner Carousel
      // --------------------
      once("partnerSwiperInit", ".partners-carousel", context).forEach(
        (wrapper) => {
          const el = wrapper.querySelector(".partnerSwiper");

          new Swiper(el, {
            loop: true,
            speed: 600,
            spaceBetween: 22,
            slidesPerGroup: 1,
            loopAdditionalSlides: 8,

            autoplay: {
              delay: 2500,
              disableOnInteraction: true,
            },

            navigation: {
              nextEl: wrapper.querySelector(".partner-next"),
              prevEl: wrapper.querySelector(".partner-prev"),
            },

            breakpoints: {
              425: { slidesPerView: 1 },
              600: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              992: { slidesPerView: 5 },
              1200: { slidesPerView: 6 },
              1440: { slidesPerView: 8 },
            },
          });
        },
      );
    },
  };
})(Drupal, drupalSettings);
